import React from "react";
import { APIParser } from "./api-parser";
import { NEW_API_URL, API_URL } from "./api-client";
import { getToken } from "./api-util";
import { config } from "../../util/axios-config";
import triyoAPI from "./triyo";
import axios from "axios";

const authMvc = window["APP_SETTINGS"].AUTH_MVC;

export const GetCurrentUser = () => {
  if (authMvc === "TRUE") {
    return fetch(API_URL + "GetCurrentUser" + "/0", {
      method: "GET",
      credentials: "include",
    }).then((response) => response.json());
  } else {
    let token = getToken();
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(NEW_API_URL + "user/legacy/currentuser", requestOptions).then(
      (response) => APIParser(response)
    );
  }
};

export const GetCurrentUserNewAPI = () => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(NEW_API_URL + "users/GetCurrentUser", requestOptions).then(
    (response) => APIParser(response)
  );
};

export const UserLogin = (loginObj) => {
  if (authMvc === "TRUE") {
    console.log("UserLogin MVC -->");
    let filterJson = JSON.stringify(loginObj);
    return fetch(API_URL + "Login" + "/0", {
      method: "POST",
      body: filterJson,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => APIParser(response));
  } else {
    console.log("UserLogin non-MVC -->");
    let filterJson = JSON.stringify(loginObj);
    return fetch(NEW_API_URL + "users/Login", {
      method: "POST",
      body: filterJson,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => APIParser(response));
  }
};

export const AzureUserLogin = async (data) => {
  if (!data) {
    throw new Error("AzureLogin requires login object parameters");
  }

  try {
    const response = await triyoAPI.post("users/AzureLogin", data, config("POST"));
    return response.data;
  } catch (err) {
    console.error("Error fetching AzureLogin", err);
    throw err;
  }
};

export const GetGraphTokenByToken = async (data) => {
  if (!data) {
    throw new Error("GetGraphTokenByToken requires token parameters");
  }

  try {
    const response = await triyoAPI.post("users/GetGraphTokenByToken", data, config("POST"));
    console.log("GetGraphTokenByToken response", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching GetGraphTokenByToken", err);
    throw err;
  }
};

export const getTokenFromLogin = async (userCredentials) => {
  if (authMvc === "TRUE") {
    const { data } = await axios.post(NEW_API_URL + "users/Login", userCredentials, { withCredentials: true });
    console.log("getTokenFromLogin => MVC flow");
    console.log(data);
    return data.AccessToken;
  } else {
    let token = getToken();
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    let requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(NEW_API_URL + "user/legacy/login", requestOptions).then(
      (response) => {
        return response.AccessToken;
      }
    );
  }
};

export const UserLogout = async () => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  if (authMvc === "TRUE") {
    return await fetch(API_URL + "Logout" + "/0", {
      method: "GET",
      credentials: "include",
    });
  } else {
    return await fetch(NEW_API_URL + "users/Logout", {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    });
  }
};

export const LoginContext = React.createContext({
  userID: 1,
  logged: true,
  token: "",
});
